import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ResultsService } from 'src/app/services/results.service';
import { SynchId, Synchable } from 'src/app/model/synchronizer';
import { IconButtonComponent } from 'src/app/components/icon-button/icon-button.component';
@Component({
  selector: 'app-synch-button',
  templateUrl: './synch-button.component.html',
  styleUrls: ['./synch-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SynchButtonComponent implements OnInit {

  private _swapped: boolean = false;
  @Input() set swapped(isIt: boolean | 'true' | 't') {
    this._swapped = (['t', 'true', true].indexOf(isIt) > -1);
  }
  get swapped(): boolean | 'true' {
    return this._swapped;
  }

  @Input() synchId: SynchId = '';
  @Input() remoteId: SynchId = '';
  private _paused = false;
  @Input() set paused(isPaused: boolean) {
    this._paused = isPaused;
  }
  get paused(): boolean {
    return this._paused;
  }
  @Input() set synching(state: boolean) {
    this._synching = state;
    this.synchingChange.emit(this._synching);
    this.Toggle(this._synching, false);
  }
  get synching() {
    return this._synching;
  }
  @Output() synchingChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() stateIcon = '';
  @Input() fromIcon = '';
  @Input() toIcon = '';
  @Input() synchTitle = 'Toggle synch for';
  @Input() fromTitle = 'Set channel to from-channel';
  @Input() toTitle = 'Set channel to to-channel';
  @Input() channel: string | number = '-1';
  @Input() default:'from'|'to' = 'to';

  private _synching = false;
  @ViewChild('stateButton') stateButton: IconButtonComponent;

  constructor(private resultsSvc: ResultsService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {

  }
  SynchChannel(which) {
    // this.Toggle(false, false);
    if (this._swapped === true) {
      if (which === 'from') {
        which = 'to';
      } else {
        which = 'from';
      }
    }
    switch (which) {
      case 'from':
        if (this.synchId === '') {
          return;
        }
        if (this.remoteId === '') {
          return;
        }
        this.SynchFromChannel();
        break;
      case 'to':
        if (this.synchId === '') {
          return;
        }
        if (this.remoteId === '') {
          return;
        }
        this.SynchToChannel();
        break;
    }
  }
  public SynchFromChannel() {
    // this.Toggle(false, false);
    this.resultsSvc.Synch(
      {
        channel: this.channel,
        data: this.resultsSvc.history.GetMoment(this.channel),
        source: this.synchId,
        topic: 'synch ' + this.synchId + ' from ' + this.remoteId,
        synchronizing: this.synching
      }
    );
    this.cdr.detectChanges();
    /*
    const mySynchable: Synchable = this.resultsSvc.GetSynchable(this.synchId);
    const remoteSynchable: Synchable = this.resultsSvc.GetSynchable(this.remoteId);
    if (!!mySynchable && !!remoteSynchable) {
      mySynchable.channel = remoteSynchable.channel;
    }
    this.resultsSvc.Synch({
      channel: mySynchable.channel,
      data: { from: this.synchId, to: this.remoteId },
      source: this.synchId,
      topic: 'channel-synch'
    });
    */
  }
  public SynchToChannel() {
    // this.Toggle(false, false);

    this.resultsSvc.Synch(
      {
        channel: this.channel,
        data: this.resultsSvc.history.GetMoment(this.channel),
        source: this.synchId,
        topic: 'synch ' + this.synchId + ' to ' + this.remoteId,
        synchronizing: this.synching
      }
    );
    this.cdr.detectChanges();

    /*
    const mySynchable: Synchable = this.resultsSvc.GetSynchable(this.synchId);
    const remoteSynchable: Synchable = this.resultsSvc.GetSynchable(this.remoteId);
    if (!!mySynchable && !!remoteSynchable) {
      remoteSynchable.channel = mySynchable.channel;

    }
    this.UpdateSynching();
    this.resultsSvc.Synch({
      channel: mySynchable.channel,
      data: { from: this.remoteId, to: this.synchId },
      source: this.synchId,
      topic: 'channel-synch'
    });
    */
  }
  UpdateSynching() {
    const mySynchable: Synchable = this.resultsSvc.GetSynchable(this.synchId);
    const remoteSynchable: Synchable = this.resultsSvc.GetSynchable(this.remoteId);
    const remoteIndex = mySynchable.synchables.indexOf(this.remoteId);
    const remoteMyIndex = remoteSynchable.synchables.indexOf(this.synchId);
    // Either add mySychable and remoteSychable to each other's synchable arrays or
    // remove them from each other's arrays.
    if (this.synching) {
      if (remoteIndex === -1) {
        mySynchable.synchables.push(this.remoteId);
      }
      if (remoteMyIndex === -1) {
        remoteSynchable.synchables.push(this.synchId);
      }
    } else {
      if (remoteIndex !== -1) {
        mySynchable.synchables.splice(remoteIndex, 1);
      }
      if (remoteMyIndex !== -1) {
        remoteSynchable.synchables.splice(remoteMyIndex, 1);
      }
    }
    this.cdr.detectChanges();


  }
  Toggle(isOn: boolean, notify: boolean = false) {
    if (this._synching !== isOn) {
      this._synching = isOn;
      this.cdr.detectChanges();
    }
    /*
        if (!!this.stateButton) {
          if (!!this.stateButton.Toggle) {
            this.stateButton.Toggle(isOn, notify);
          }
        }
    */
  }

  HandleClick(e: MouseEvent) {
    if(this.synching) {
      this.HandleDblClick(e);
      return;
    }
    this.SynchChannel(this.default);
  }

  HandleDblClick(e: MouseEvent) {
    if (this.paused === true) {
      return;
    }
    const wasOn = this.synching;
    const isOn = (e.currentTarget as HTMLButtonElement).classList.contains('btn-primary');
    if (wasOn === isOn) {
      return;
    }

    const mySynchable: Synchable = this.resultsSvc.GetSynchable(this.synchId);
    if (isOn) {
      this.SynchToChannel();
    }
    this.paused = true;
    this.resultsSvc.Synch({
      channel: mySynchable.channel,
      data: { state: isOn },
      source: this.synchId,
      topic: 'synch-state-change',
      synchTo: [this.synchId, this.remoteId].join(','),
      synchFrom: this.synchId,
      synchronizing: this.synching
    });
    this.paused = false;
    this.synching = isOn;
    this.UpdateSynching();
    this.synchingChange.emit(isOn);
    this.cdr.detectChanges();
  }

}
